import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a20fb21a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20fb21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a20fb21a')) {
      api.createRecord('a20fb21a', component.options)
    } else {
      api.reload('a20fb21a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a20fb21a&scoped=true&", function () {
      api.rerender('a20fb21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VideoPlayerDialog/index.vue"
export default component.exports